<template>
  <div v-if="currentMsg" class="marquee-wrapper">
    <img class="w-[20px] h-[20px] marquee-icon" src="../img/notice.webp" alt="" />
    <div class="marquee-container">
      <div class="marquee" :key="animKey" @animationend="next">
        ***{{ currentMsg.nickName.slice(-2) }}
        {{ $t('goldenFlower.in') }}
        <span class="marquee-room">{{ $t(`goldenFlower.${roomName[currentMsg.hallName]}`) }}</span>
        <span class="marquee-win">{{ $t('goldenFlower.winValue', { val: getFixed(currentMsg.winAmount)}) }}</span>
        {{ $t('goldenFlower.amazing') }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';

const props = defineProps({
  list: {
    type: Array,
    required: true,
  },
});

const currentIndex = ref(0);
const idle = ref(false);
const animKey = ref(0);
const { locale } = useNuxtApp().$i18n;
const currentMsg = computed(() => (idle.value ? null : props.list[currentIndex.value]));

const roomName = {
  trial: 'novice',
  casual: 'leisure',
  premium: 'flagship',
  rick: 'royal',
  vip: 'supreme',
};

watch(
  () => props.list.length,
  (newLen) => {
    if (idle.value && newLen > currentIndex.value + 1) {
      idle.value = false;
      currentIndex.value = currentIndex.value + 1;
      animKey.value++;
    }
  },
);

function next() {
  if (currentIndex.value < props.list.length - 1) {
    currentIndex.value++;
    animKey.value++;
  } else {
    idle.value = true;
  }
}
</script>

<style scoped>
.marquee-wrapper {
  overflow: hidden;
  white-space: nowrap;
  background: rgba(11, 122, 82, 0.3);
  border: 1.17px solid rgba(0, 153, 81, 1);
  text-align: center;
  padding: 2px 6px;
  font-size: 12px;
  display: flex;
  align-items: center;
  border-radius: 24px;
}

.marquee-icon {
  margin-right: 2px;
  flex: 0 0 auto;
}

.marquee-container {
  flex: 1 1 auto;
  overflow: hidden;
  min-width: 0;
}

.marquee {
  display: inline-block;
  padding-left: 100%;
  animation: marquee 10s linear forwards;
}

.marquee-room {
  color: rgba(201, 94, 255, 1);
}

.marquee-win {
  color: rgba(255, 197, 28, 1);
}

@keyframes marquee {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-100%);
  }
}
</style>
